import * as React from 'react';
import { LinkButton } from '../../Common/LinkButton';
import './style.css';

export interface SignUpBenefitsProps {
  /* empty */
}

export interface SignUpBenefitsState {
  /* empty */
}

export class SignUpBenefits extends React.Component<
  SignUpBenefitsProps,
  SignUpBenefitsState
> {
  render() {
    return (
      <div className="sign-up-benefits">
        <h2 className="sign-up-benefits-heading">
          Sign up for more edge of play content
        </h2>
        <section className="sign-up-benefits-content">
          Want to be notified the moment a new video is uploaded? Want to keep
          track of your favourite videos and training documents? Sign up to Edge
          of Play and we’ll keep you up to date! No spam, just content. Use Edge
          of Play for:
          <ul className="sign-up-benefits-list">
            <li className="sign-up-benefits-list-item">
              Hundreds of videos covering the following key areas: Technical;
              Tactical; Small Sided Games; Physical and Mind & Body.
            </li>
            <li className="sign-up-benefits-list-item">
              Coach’s Profile – allowing you to favourite the videos you like
              best and manage your account with us.
            </li>
            <li className="sign-up-benefits-list-item">
              Downloadable Session Plans.
            </li>
            <li className="sign-up-benefits-list-item">
              Share your favourite videos across social media.
            </li>
          </ul>
        </section>
        <div className="sign-up-benefits-link-wrapper">
          <LinkButton to="/sign-up">Sign Up Now</LinkButton>
        </div>
      </div>
    );
  }
}

export default SignUpBenefits;



// WEBPACK FOOTER //
// ./src/app/components/Home/SignUpBenefits/index.tsx